const IconMinus = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden className={className}>
    <path
      d="M4 16H28"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
    />
  </svg>
);

export default IconMinus;
